/**
 * Phase 7 — Shared form constants for QuickRequestSheet.
 * Mirrors the canonical lists used in /plan Step 2 and Step 6 so both flows
 * stay consistent.
 */

export const CITIES = [
  "Mumbai",
  "Delhi",
  "Bengaluru",
  "Chennai",
  "Hyderabad",
  "Pune",
  "Kolkata",
  "Ahmedabad",
  "Jaipur",
  "Goa",
  "Udaipur",
  "Jodhpur",
  "Lucknow",
  "Chandigarh",
  "Other",
];

export const COUNTRY_CODES = [
  { code: "+91", flag: "🇮🇳" },
  { code: "+1", flag: "🇺🇸" },
  { code: "+44", flag: "🇬🇧" },
  { code: "+971", flag: "🇦🇪" },
  { code: "+65", flag: "🇸🇬" },
  { code: "+61", flag: "🇦🇺" },
];

export const BEST_TIME_OPTIONS = [
  { key: "morning", label: "Morning" },
  { key: "afternoon", label: "Afternoon" },
  { key: "evening", label: "Evening" },
  { key: "anytime", label: "Anytime" },
  { key: "whatsapp_only", label: "WhatsApp only" },
];

export const GUEST_BANDS = [
  { key: "intimate", label: "Intimate (<50)" },
  { key: "mid", label: "Mid (50–150)" },
  { key: "large", label: "Large (150–400)" },
  { key: "very_large", label: "Very large (400+)" },
];
